export default (Vue, options = {}) => {
	Vue.filter('upperCase', function(value) {
		if (!value) return ''
		value = value.toString()
		return value.toUpperCase()
	})
	Vue.filter('lowerCase', function(value) {
		if (!value) return ''
		value = value.toString()
		return value.toLowerCase()
	})

	Vue.filter('dateFormat',function(value,format) {
		if (!format || format == 'YYYY-MM-DD') return value.replace('T',' ').substring(0,10)
		if (format == 'YYYY-MM-DD HH:mm:ss') return value.replace('T',' ')
	})
	Vue.filter('capitalize', function(value) {
		if (!value) return ''
		value = value.toString()
		return value.charAt(0).toUpperCase() + value.slice(1)
	})
	Vue.filter('noHTML', function(value) {
		let el = document.createElement('div')
		el.innerHTML = value
		return el.innerText
	})

	Vue.filter('numberFormat', function(value) {
		if (!value) return ''
		value = value.toString()
		let items = value.split(/\b/)
		items = items.map(item => {
			if (/^\d+$/.test(item)) {
				let regex = /(?!^)(?=(\d{3})+$)/g;
				let str = item.replace(regex, ',')
				return str;
			}
			return item;

		})
		value = items.join('')
		return value
	})
}